export const isValidEmail = (email: string) => {
  const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
  return (reg.test(email) || email.split('@')[0].length > 64);
}

export const isValidPhoneNumber = (number: string) => {
  const reg = /^([49][\d]{7})$/;
  return (reg.test((number + '')));
}

export const trimPhoneNumber = (number: string) => {
  const trimmedNumber = number.replace(/\s/g, "");
  return trimmedNumber;
}